/**
 * Normalize an asset URL so it always points to the current backend.
 *
 * Why this exists: in the past, image URLs were stored as ABSOLUTE strings like
 * "https://costelao-bbq.preview.emergentagent.com/api/uploads/xxx.jpg".
 * When the preview URL changes (forks, re-deploys), those URLs 404.
 *
 * This helper rewrites any "/api/uploads/..." path to use the CURRENT backend,
 * regardless of what host was originally embedded in the saved URL.
 *
 * Behavior:
 *   - Empty / null → returns empty string
 *   - Already absolute on customer-assets.* (CDN) → unchanged
 *   - Contains "/api/uploads/<file>" → rewritten to {BACKEND_URL}/api/uploads/<file>
 *   - Plain relative "/api/uploads/..." → prefix with backend
 *   - Anything else (external image, data URL, etc.) → unchanged
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const normalizeAssetUrl = (url) => {
  if (!url || typeof url !== 'string') return '';

  // Find "/api/uploads/<file>" anywhere in the string and rewrite host
  const match = url.match(/\/api\/uploads\/[^?#]+/);
  if (match) {
    return `${BACKEND_URL}${match[0]}`;
  }

  // Already a full external URL (CDN, customer-assets, etc.) — leave alone
  return url;
};

export default normalizeAssetUrl;
